module.exports = __webpack_public_path__ + "static/img/nav_fix2.d8366eb4.png";